import { removeDuplicates } from "./array";

export const getCascadedValues = <T extends string, U>(
  values: T[],
  map: Record<T, U[]>
): U[] => {
  const cascadedValues = values.flatMap((value) => map[value]);
  return removeDuplicates(cascadedValues as string[]) as U[];
};
